module.exports = __webpack_public_path__ + "img/loading.82b9c7a5.png";